import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { MenuService } from '@shared/core';
import { IMenu } from '@shared/models/menu';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent {
  // NOTE: Ripple effect make page flashing on mobile
  @Input() ripple = false;
  @Input() isMobile = false;

  menu$ = this.menu.getValidMenuItems();
  menuResponse: IMenu[] = [];
  buildRoute = this.menu.buildRoute;
  @Output() toggleCollapsed = new EventEmitter<void>();

  constructor(private menu: MenuService) { }

  ngOnInit() {
    //This sets up the namespace required for translating the sidebar options
    this.menu$.subscribe(
      response => {
        if(environment.translateText){
          this.menu.addNamespace(response, 'menu');
        }
      }
    )
  }

}